import { Component, OnInit } from '@angular/core';
import { map } from "rxjs/operators";
import { SitesDataService } from '../data-storage/sites-data.service';
import { SiteDto } from '../../../dtos/siteDto';
import { GlobalDataService } from '../../../shared-services/global-data.service';
import { PanoramaImages } from '../../../dtos/panoramaImages';
import { Router } from '@angular/router';
import { OperatorFunction } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { debounceTime } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

const statesWithFlags: {name: string, country: string, region: string, state: string}[] = [
    {'name': 'Ancient Corinth', 'country': 'Greece', 'region': 'Peloponnese', 'state': 'Corinth'}
];

@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {

    sites: SiteDto[];

    constructor(private siteDataService: SitesDataService,
                public  globalDataService: GlobalDataService,
                private router: Router,
                public translateService:TranslateService) {
    }

    videoPlay: boolean;
    activeSite: SiteDto;
    flowLoading: boolean = true;
    model: any;

    search: OperatorFunction<string, readonly {name: string, country: string, region: string, state: string}[]> = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            map(term => term === '' ? []
                : statesWithFlags.filter(v => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
        )

    formatter = (x: {name: string}) => x.name;

    ngOnInit(): void {
        //this.startChatPort();

    }

    private startChatPort() {
        (function (w, d, v3) {
            w['chaportConfig'] = {
                appId: '5efdb5fa1b4b08234a76d101'
            };

            if (w['chaport']) return;
            v3 = w['chaport'] = {};
            v3._q = [];
            v3._l = {};
            v3.q = function () {
                v3._q.push(arguments)
            };
            v3.on = function (e, fn) {
                if (!v3._l[e]) v3._l[e] = [];
                v3._l[e].push(fn)
            };
            var s = d.createElement('script');
            s['type'] = 'text/javascript';
            s['async'] = true;
            s['src'] = 'https://app.chaport.com/javascripts/insert.js';
            var ss = d.getElementsByTagName('script')[0];
            ss.parentNode.insertBefore(s, ss)
        })(window, document);
    }
}
